module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Shop Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Shop Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-shop-devin",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('a', {
    attrs: {
      "href": "#featured",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("featured")])]), _vm._v(" "), _c('li', {
    staticClass: "active",
    attrs: {
      "data-wow-delay": "0.4s"
    }
  }, [_c('a', {
    attrs: {
      "href": "#best",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("bestsellers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-wow-delay": "0.2s"
    }
  }, [_c('a', {
    attrs: {
      "href": "#new",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("new")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "featured"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "role": "tabpanel",
      "id": "best"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "new"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "product-item-thumbnail-label"
  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-thumbnail text-center mb-15"
  }, [_c('a', {
    staticClass: "product-item-thumbnail-link",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-item-thumbnail-overlay"
  }, [_c('a', {
    staticClass: "btn btn-default pulse",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-heart mr-0"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "h5",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('del', {
    staticClass: "h5 text-muted product-item-price-old"
  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
    staticClass: "h5 product-item-price"
  }, [_vm._v("$49.00")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-277e72ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ShopHome.vue
// module id = 1356
// module chunks = 2